import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../../infra/hooks";
import { salaryService } from "../../../../api/services/salaryService";
import {
  setSalaryStartDate,
  setPaymentMethod,
} from "../../../../infra/aggregates/myProfile/salaryAggregates/updatedSalaryDateSlice";
import { useAppDispatch } from "../../../../infra/hooks";
import _ from "lodash";

//--> allowance and other allownace slices
import { setEmployeeAllowance } from "../../../../infra/aggregates/myProfile/salaryAggregates/allowanceSlice";
import { setEmployeeOtherAllowance } from "../../../../infra/aggregates/myProfile/salaryAggregates/otherAllowanceSlice";
import { setCurrentSalaryLoader } from "../../../../infra/aggregates/myProfile/salaryAggregates/salaryLoadersSlice";

interface PropsValues {
  setAllEmpAllowances: (data: any) => void;
  setAllEmpAdditionalBenefits: (data: any) => void;
  setTotalNetSalary: (data: any) => void;
  setStartDate: (data: any) => void;
  setCurrency: (data: any) => void;
}

function DTOCurrentSalary({
  setAllEmpAdditionalBenefits,
  setAllEmpAllowances,
  setTotalNetSalary,
  setStartDate,
  setCurrency,
}: PropsValues) {
  const emp_id: number = useAppSelector((state) => state.authSlice.emp_id);

  const additionalBenefits: any = useAppSelector(
    (state) => state.otherAllowanceSlice.otherAllowance
  );
  const allowances: any = useAppSelector(
    (state) => state.allowanceSlice.allowance
  );

  const start_date_of_salary: any = useAppSelector(
    (state) => state.updatedSalaryDateSlice.start_date
  );

  const current_currency = useAppSelector((state) => state.authSlice.currency);
  const dispatch = useAppDispatch();

  async function getCurrentEmpSalary(empId: number) {
    dispatch(setCurrentSalaryLoader(true));
    const response: any = await salaryService.getEmployeeCurrentSalary(empId);

    if (response.response == "success") {
      const salaryAllowance: any = response?.data[0]?.salary_allowance;
      const additionalBenefits: any = response?.data[0]?.additional_benefits;

      dispatch(setEmployeeAllowance(salaryAllowance));
      dispatch(setEmployeeOtherAllowance(additionalBenefits));
      dispatch(setSalaryStartDate(response?.data[0]?.start_date));
      dispatch(setPaymentMethod(response?.data[0]?.payment_method));

      let allowanceSum = 0;
      let benefitSum = 0;
      let totalNetSalary = 0;

      if (salaryAllowance?.length) {
        _.map(salaryAllowance, (allowance) => {
          return (allowanceSum = allowanceSum + allowance.value);
        });
      }
      if (additionalBenefits?.length) {
        _.map(additionalBenefits, (benefit) => {
          return (benefitSum = benefitSum + benefit.amount);
        });
      }

      totalNetSalary = allowanceSum + benefitSum;

      /* Passing Props to Controller */
      setAllEmpAllowances(salaryAllowance);
      setAllEmpAdditionalBenefits(additionalBenefits);
      setTotalNetSalary(totalNetSalary);
      setStartDate(response?.data[0]?.start_date);
      setCurrency(current_currency);
      dispatch(setCurrentSalaryLoader(false));
    }
  }

  useEffect(() => {
    setAllEmpAllowances(allowances);
    setAllEmpAdditionalBenefits(additionalBenefits);
    let allowanceSum = 0;
    let benefitSum = 0;
    let totalNetSalary = 0;

    if (allowances?.length) {
      _.map(allowances, (allowance) => {
        return (allowanceSum = allowanceSum + allowance.value);
      });
    }
    if (additionalBenefits?.length) {
      _.map(additionalBenefits, (benefit) => {
        return (benefitSum = benefitSum + benefit.amount);
      });
    }

    totalNetSalary = allowanceSum + benefitSum;
    setTotalNetSalary(totalNetSalary);
    setStartDate(start_date_of_salary);
    setCurrency(current_currency);
  }, [allowances, additionalBenefits, start_date_of_salary]);

  useEffect(() => {
    getCurrentEmpSalary(emp_id);
  }, []);

  return <></>;
}
export default DTOCurrentSalary;
